import React, { Component } from 'react';
import { TableCell } from '@mui/material';
import { formatCurrency } from '../../utils/formatNumber';


export default class GridAmountCell extends Component {
    //props: value, id, field
    // field.currencyObject names a nested object on the row whose code formats this
    // amount — a currency ('balanceCurrency', read as .code) or anything carrying a
    // .currencyCode (a wallet's 'balance'); without it, row.currency is used as before.
    // field.blankWhenNull shows nothing for a null amount, where 0.00 would read as a
    // real figure (a payin's payableAmount, set only on some gateways).
    render() {
        const value = this.props.value;
        const { currencyObject, blankWhenNull } = this.props.field;
        const nested = currencyObject ? this.props.row[currencyObject] : null;
        const currencyCode = currencyObject ? nested?.code ?? nested?.currencyCode : this.props.row.currency;
        // No object behind the amount at all (the API sent no balance for the row):
        // a dash, where "0.00" without its currency read as a real figure.
        const missing = currencyObject && !nested && value == null;
        let formattedAmount = formatCurrency(value, currencyCode);
        if (blankWhenNull && value == null) formattedAmount = '';
        else if (missing) formattedAmount = '—';
        const baseStyle = this.props.styles;
        return (
            <TableCell key={this.props.field.id} align="right" sx={{ ...baseStyle }}>
                {formattedAmount}
            </TableCell>
        );
    }
}
